import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./lib/auth.jsx";
import { JournalProvider } from "./lib/journal.jsx";
import "./styles.css";
import "./styles-additions.css";

import Home from "./pages/Home.jsx";
import TechniquesIndex from "./pages/TechniquesIndex.jsx";
import TechniqueDetail from "./pages/TechniqueDetail.jsx";
import BeginnerPath from "./pages/BeginnerPath.jsx";
import BeginnerPathDay from "./pages/BeginnerPathDay.jsx";
import FortyDay from "./pages/FortyDay.jsx";
import FortyDayDay from "./pages/FortyDayDay.jsx";
import FindMyDoorway from "./pages/FindMyDoorway.jsx";
import About from "./pages/About.jsx";
import PublishedBooks from "./pages/PublishedBooks.jsx";
import Journal from "./pages/Journal.jsx";
import SignIn from "./pages/SignIn.jsx";
import NotFound from "./pages/NotFound.jsx";
import Layout from "./components/Layout.jsx";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AuthProvider>
        <JournalProvider>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/techniques" element={<TechniquesIndex />} />
              <Route path="/technique/:id" element={<TechniqueDetail />} />
              <Route path="/beginner-path" element={<BeginnerPath />} />
              <Route path="/beginner-path/day/:n" element={<BeginnerPathDay />} />
              <Route path="/40-day-challenge" element={<FortyDay />} />
              <Route path="/40-day-challenge/day/:n" element={<FortyDayDay />} />
              <Route path="/find-my-doorway" element={<FindMyDoorway />} />
              <Route path="/about" element={<About />} />
              <Route path="/published-books" element={<PublishedBooks />} />
              <Route path="/journal" element={<Journal />} />
              <Route path="/sign-in" element={<SignIn />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </JournalProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
